import { forwardRef } from 'react';

import ButtonProps from 'styled/components/Button/Button.types';
import StyledButton, { StyledButtonContent } from 'styled/components/Button/Button.styled';

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props: ButtonProps, ref) => {
  const { href } = props;
  const { allowVisited = false, children, tailIcon, size = 'base', leadIcon, variant, ...forwardProps } = props;

  const element = href ? 'a' : 'button';

  if (size === 'xsmall' && variant !== 'text') {
    throw new Error('Size `xsmall` can be used only with the `text` variant');
  }

  return (
    <StyledButton {...forwardProps} $allowVisited={element === 'a' && allowVisited} $size={size} $variant={variant} as={element} ref={ref}>
      <StyledButtonContent $variant={variant}>
        {leadIcon}
        {children}
        {tailIcon}
      </StyledButtonContent>
    </StyledButton>
  );
});

export default Button;
